export const Loader = () => {
  return (
    <div id="loader">
      <div className="lds-ripple"></div>
    </div>
  );
};
